export default "__VITE_ASSET__b5dd86ca__"